import SiteLayout from "@/components/feature/SiteLayout";
import PageBanner from "@/components/feature/PageBanner";
import AboutSubNav from "@/components/feature/AboutSubNav";
import { ceoMessage } from "@/mocks/about";

export default function AboutCeoPage() {
  return (
    <SiteLayout navVariant="solid">
      <PageBanner
        title="CEO 인사말"
        subtitle="고객의 문제를 함께 해결하는 기술 파트너"
        breadcrumb={[
          { label: "회사소개", to: "/about/overview" },
          { label: "CEO 인사말" },
        ]}
        bgImage="https://readdy.ai/api/search-image?query=Modern%20clean%20industrial%20manufacturing%20facility%20interior%20with%20organized%20production%20floor%20and%20natural%20light%20streaming%20through%20windows%2C%20professional%20engineering%20environment%2C%20warm%20industrial%20aesthetic%2C%20soft%20ambient%20lighting%2C%20crisp%20architectural%20photography&width=1600&height=680&seq=krubber-about-banner&orientation=landscape"
      />
      <AboutSubNav />
      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            <div className="lg:w-[360px] flex-shrink-0 flex flex-col items-center">
              <div className="mt-6 text-center">
                <p className="font-heading font-bold text-lg text-foreground-950">{ceoMessage.name}</p>
                <p className="text-sm text-foreground-600 mt-1">{ceoMessage.title}</p>
              </div>
              <div className="mt-8 w-full max-w-[280px] p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <p className="font-heading text-lg font-bold text-primary-600 leading-snug">
                  &ldquo;{ceoMessage.greeting}&rdquo;
                </p>
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="prose prose-base max-w-none text-foreground-800 leading-relaxed whitespace-pre-line">
                {ceoMessage.body}
              </div>
              <div className="mt-10 pt-8 border-t border-background-200/70">
                <p className="text-right font-heading font-bold text-foreground-950">
                  {ceoMessage.signature}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}